/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type CreateAssetForProjectMutationVariables = Types.Exact<{
    input: Types.CreateAssetForProjectInput;
}>;

export type CreateAssetForProjectMutation = {
    __typename: 'Mutation';
    createAssetForProject: {
        __typename: 'CreateAssetForProjectResponse';
        requestReceived: boolean;
    };
};

export const CreateAssetForProjectDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CreateAssetForProject' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'CreateAssetForProjectInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createAssetForProject' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'requestReceived' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type CreateAssetForProjectMutationFn = Apollo.MutationFunction<
    CreateAssetForProjectMutation,
    CreateAssetForProjectMutationVariables
>;

/**
 * __useCreateAssetForProjectMutation__
 *
 * To run a mutation, you first call `useCreateAssetForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetForProjectMutation, { data, loading, error }] = useCreateAssetForProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetForProjectMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateAssetForProjectMutation,
        CreateAssetForProjectMutationVariables
    >
) {
    return Apollo.useMutation<
        CreateAssetForProjectMutation,
        CreateAssetForProjectMutationVariables
    >(CreateAssetForProjectDocument, baseOptions);
}
export type CreateAssetForProjectMutationHookResult = ReturnType<
    typeof useCreateAssetForProjectMutation
>;
export type CreateAssetForProjectMutationResult =
    Apollo.MutationResult<CreateAssetForProjectMutation>;
export type CreateAssetForProjectMutationOptions = Apollo.BaseMutationOptions<
    CreateAssetForProjectMutation,
    CreateAssetForProjectMutationVariables
>;
